import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AuthProvider } from './contexts/AuthContext'
import { AdminProvider } from './contexts/AdminContext'
import { ChatProvider } from './contexts/ChatContext'
import { ModerationProvider } from './contexts/ModerationContext'
import { ThemeProvider } from './providers/ThemeProvider'
import ErrorBoundary from './components/ErrorBoundary'
import { FloatingChatButton } from './components/Chat/FloatingChatButton'
import { ChatModal } from './components/Chat/ChatModal'
import App from './App.tsx'
import './index.css'

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ModerationProvider>
          <AuthProvider>
            <ChatProvider>
              <AdminProvider>
                <BrowserRouter>
                  <ThemeProvider>
                    <App />
                    <FloatingChatButton />
                    <ChatModal />
                  </ThemeProvider>
                </BrowserRouter>
              </AdminProvider>
            </ChatProvider>
          </AuthProvider>
        </ModerationProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)